<template>
    <div class="input-group pb-4">
        <span v-if="before.length > 0" class="input-group-text" v-html="before"></span>
        <input
            v-if="setting === null"
            class="form-control form-control-alt is-invalid"
            readonly
            value="Warning setting is missing"
        />
        <input
            v-else
            ref="theInput"
            v-model="newValue"
            type="text"
            class="form-control"
            :class="{'is-invalid': invalid === true}"
            required
            :readonly="loading === true"
            v-on:blur="save"
            v-on:keyup.enter="save"
            v-on:keyup.esc="reset"
        />
        <span v-if="after.length > 0" class="input-group-text" v-html="after"></span>
        <span v-if="loading !== null" class="input-group-text">
            <div v-if="loading === true" class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <i v-else class="fa fa-check"></i>
        </span>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        route: String,
        setting: Object,
    },
    data () {
        return {
            after: '',
            before: '',
            invalid: false,
            loading: null,
            newValue: null,
        };
    },
    mounted () {
        if (this.setting === null) {
            return;
        }

        this.reset();

        switch (this.setting.unit) {
            case '%':
                this.after = this.setting.unit;
                break;
            case 'p':
                this.before = '&pound;';
                break;
            case 's':
                this.after = 'seconds';
                break;
        }
    },
    methods: {
        reset () {
            this.newValue = this.setting.value;

            if (this.setting.unit == 'p') {
                this.newValue /= 100;
            }
        },
        save () {
            this.invalid = ! this.$refs.theInput.checkValidity();

            if (this.invalid) {
                return;
            }

            let valueToSend = this.newValue;

            if (this.setting.unit == 'p') {
                valueToSend *= 100;
            }

            this.loading = true;
            axios.post(
                this.route,
                {
                    name: this.setting.name,
                    value: valueToSend,
                }
            ).then((response) => {
                if (response.data.success !== true) {
                    throw new Error('unable to save');
                }

                this.loading = false;

                setTimeout(() => {
                    this.loading = null;
                }, 1000);
            }).catch((error) => {
                this.invalid = true;
                this.loading = null;
                let status = 'Unknown';
                if (error.response) {
                    status = error.response.status;

                    if (status === 422) {
                        // no need to swal
                        return;
                    }
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Could not update setting',
                    text: 'System error: ' + status,
                });
            });
        },
    }
}
</script>
